import { useMemo } from 'react'

import cls from 'classnames'
import { Remarkable } from 'remarkable'

import { MarkdownStyled } from './index.styled'

const getMDInstance = () => {
  return new Remarkable('full', {
    html: true,
    linkTarget: '_blank',
  })
}

export const parseMarkdown = (str?: string): string => {
  if (!str) {
    return ''
  }

  const md = getMDInstance()

  return md.render(str)
}

const Markdown = ({
  children,
  className,
  ...restProps
}: React.ComponentProps<typeof MarkdownStyled>) => {
  const md = useMemo(() => getMDInstance(), [])
  const classes = cls(className, 'markdown')
  const props = useMemo(() => {
    const newProps: React.ComponentProps<typeof MarkdownStyled> = {
      ...restProps,
    }
    if (typeof children === 'string') {
      newProps.dangerouslySetInnerHTML = { __html: md.render(children) }
    } else {
      newProps.children = children
    }
    return newProps
  }, [children])
  return <MarkdownStyled {...props} className={classes} />
}

export { Markdown }
